var map = {
	"./Agent.png": 8237,
	"./Conga_CPQ_201_Adminstration.png": 1819,
	"./Conga_CPQ_201_Adminstration_2.png": 6946,
	"./Datacloud.png": 5927,
	"./Experience_Cloud.png": 4135,
	"./Lightning.png": 8802,
	"./Omnistudio.png": 7295,
	"./Salesforce_Communications_Cloud.png": 4472,
	"./Salesforce_Health_Cloud.png": 8688,
	"./Salesforce_Public_Sector_Solutions.png": 9473,
	"./Salesforce_Revenue_Lifecycle_Management.png": 1090,
	"./Salesforce_Sales_Cloud.png": 1593,
	"./praveen.rajaram.png": 6614,
	"./sfimg-1.png": 8295,
	"./sfimg-10.png": 6704,
	"./sfimg-11.png": 8559,
	"./sfimg-12.png": 300,
	"./sfimg-13.png": 8604,
	"./sfimg-14.png": 3967,
	"./sfimg-15.png": 4042,
	"./sfimg-16.png": 1577,
	"./sfimg-17.png": 2407,
	"./sfimg-18.png": 6840,
	"./sfimg-19.png": 3911,
	"./sfimg-2.png": 490,
	"./sfimg-20.png": 5390,
	"./sfimg-3.png": 4989,
	"./sfimg-4.png": 3050,
	"./sfimg-5.png": 2429,
	"./sfimg-6.png": 3539,
	"./sfimg-7.png": 8985,
	"./sfimg-8.png": 4854,
	"./sfimg-9.png": 2186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5045;